import React from 'react';
import { Box, Typography } from '@mui/material';

interface StepHeadingProps {
  step: number;
  totalSteps?: number;
  title: string;
  subtitle?: string;
}

const StepHeading: React.FC<StepHeadingProps> = ({ step, totalSteps = 4, title, subtitle }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="overline"
        sx={{
          color: 'primary.main',
          fontWeight: 700,
          letterSpacing: '0.08em',
          fontSize: '0.72rem',
          display: 'block',
        }}
      >
        Schritt {step} von {totalSteps}
      </Typography>
      <Typography
        variant="h4"
        component="h2"
        sx={{ fontWeight: 800, color: 'text.primary', mt: 0.5, fontSize: { xs: '1.5rem', sm: '1.9rem' } }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body1" sx={{ color: 'text.secondary', mt: 1 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default StepHeading;
